import AmpersandModel from 'ampersand-model';
import Moment from 'moment';
import React from 'react';

const EventBasic = AmpersandModel.extend({

    props: {
        id: 'string',
        type: 'number',
        isAccomplished: 'boolean',
        name: 'string',
        notes: 'string',
        startDate: 'object',
        endDate: 'object',

        userId: 'string',               //for personal events only
        projectId: 'string',
        companyId: 'string',
        assignedToUserId: 'string'
    },

    derived: {

        scope: {
            deps: ['type'],
            fn: function() {
                if (this.type>0 && this.type<10) return 'project';
                if (this.type>=10 && this.type<20) return 'organization';
                if (this.type>=20 && this.type<30) return 'personal';
                if (this.type>=30) return 'task';
                if (this.type>=40) return 'meeting';
            }
        },

        pastdue: {
            deps: ['startDate'],
            fn: function() {
                return (this.startDate.isBefore(Moment(),'days'));
            }
        },

        isProject: {
            deps: ['type'],
            fn: function() {
                return (this.type>0 && this.type<10);
            }
        },

        isOrganization: {
            deps: ['type'],
            fn: function() {
                return (this.type>=10 && this.type<20);
            }
        },

        isPersonal: {
            deps: ['type'],
            fn: function() {
                return (this.type>=20 && this.type<30);
            }
        }
    },

    session: {
        projectPath: 'string'  // Store copy in session to avoid persistence
    },

    initialize() {
        this.projectPath = this.projectId; // Copy property on initialization
    },

    initFromSession(){
        if (this.companyId)         this.company = gd.session.companies.get(this.companyId);
        if (this.projectId)         this.project = gd.session.projects.get(this.projectId);
        if (this.userId)            this.user = gd.session.users.get(this.userId);
        if (this.assignedToUserId)  this.assignedToUser = gd.session.users.get(this.assignedToUserId);
    },

    toFullCalendar: function(){

        return {
            id              : this.id,
            title           : this.name,
            allDay          : true,
            start           : this.startDate ? this.startDate.format('YYYY-MM-DD') : null,
            end             : this.endDate ? Moment(this.endDate).add(1,'day').format('YYYY-MM-DD') : null,
            eventObject     : this,
            startEditable   : gd.ac.check.event.canEditEvent(this)
        }
    },

    parse(obj) {

        obj.startDate = Moment(obj.startDate);
        obj.endDate = (obj.endDate)?Moment(obj.endDate):null;

        if (!obj.type && !!obj.eventType) obj.type = obj.eventType

        // patch - strange but will work I guess

        return obj;
    }

});

module.exports = EventBasic;
